export enum PropertyDataType {
  BOOLEAN = 1,
  DATETIME = 2,
  DECIMAL = 3,
  FLOAT = 4,
  INTEGER = 5,
  STRING = 6
}
